function heightsEqualizer(selector) {
    var elements = document.querySelectorAll(selector),
        max_height = 0,
        len = 0,
        i;
        
    if ( (elements) && (elements.length > 0) ) {
        len = elements.length;
    
        for (i = 0; i < len; i++) { // get max height
			elements[i].style.height = ''; // reset height attr
            if (elements[i].clientHeight > max_height) {
                max_height = elements[i].clientHeight;
            }
        }

        for (i = 0; i < len; i++) { // set max height to all elements
            elements[i].style.height = max_height + 'px';
        }
    }
}

if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', function() {
        heightsEqualizer('.events-equal-height');
		heightsEqualizer('.subpage-row-1');
		heightsEqualizer('.subpage-row-2');
		heightsEqualizer('.subpage-row-3');
    });
	window.addEventListener('resize', function(){
		heightsEqualizer('.events-equal-height');
		heightsEqualizer('.subpage-row-1');
		heightsEqualizer('.subpage-row-2');
		heightsEqualizer('.subpage-row-3');
	});
}

setTimeout(function () { // set 1 second timeout for having all fonts loaded
	heightsEqualizer('.events-equal-height');
	heightsEqualizer('.subpage-row-1');
	heightsEqualizer('.subpage-row-2');
	heightsEqualizer('.subpage-row-3');
}, 1000);

//# sourceMappingURL=common.js.map




var whatYouGet = (function () {
  var block = document.getElementById('sideCardComponent');
  var topMark = block.querySelector('.right-side a:first-child .ind-side-cards-sidecard');
  var bottomMark = block.querySelector('.right-side a:last-child .ind-side-cards-sidecard');
  var contentSec = block.querySelector('.content-section');
  var docElem = window.document.documentElement;

  function checkAndRemove(elm, _class) {
    if (elm.classList.contains(_class)) {
      elm.classList.remove(_class);
    }
  };
  function checkAndAdd(elm, _class) {
    if (!elm.classList.contains(_class)) {
      elm.classList.add(_class);
    }
  }

  function setContentPosition() {

    if (window.innerWidth > 1023) {
      var docElemH = docElem['clientHeight'];
      var blockTop = topMark.getBoundingClientRect().top,
        blockBottom = bottomMark.getBoundingClientRect().top,
        top = Math.ceil((blockTop / docElemH) * 100),
        bottom = Math.ceil((blockBottom / docElemH) * 100)

      if (top > 35) {
        checkAndRemove(contentSec, 'centered');
          console.log('top called', top);
      } else if (bottom < 39) {
        checkAndRemove(contentSec, 'centered');
        checkAndAdd(contentSec, 'bottom-aligned');
          console.log('bottom called', bottom);
      } else {
        checkAndAdd(contentSec, 'centered');
        checkAndRemove(contentSec, 'bottom-aligned');
        console.log('centered called');
          console.log('centered called', top);
      }
    }
  }

  function init() {
    if (window.innerWidth > 1023) {
      window.addEventListener('scroll', setContentPosition, false);
    }
  }

  return {
    init: init
  }
}());




